<template>
  <section class="p-2">
   
    <div class="mt-5">
      <div>
        <v-row justify="center">
          <v-alert
            v-if="alertMsg.status"
            :timeout="alertMsg.timeout"
            :color="alertMsg.color"
            :type="alertMsg.type"
            dismissible
            dark
            dense
          >
            {{ alertMsg.text }}
          </v-alert>
        </v-row>
      </div>
      <v-form>
        <v-card flat tile outlined class="">
          <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">New Business Deals</div>
        <div>
          <bread-crumb :bread-crumbs="['Business Deals', 'New Business Deals']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
          <v-toolbar flat dense >
            <v-toolbar-title v-if="!updateTrigger"
              class="subtitleFontsize">Deal Details</v-toolbar-title
            >
            <v-toolbar-title v-if="updateTrigger"
            class="subtitleFontsize">Basic Details</v-toolbar-title
            >
          </v-toolbar>
          <v-card-text>
          <v-row  >
            <v-col cols="12" md="4">
              <label  class="my-0 labelFontsize">Business User</label>
              <v-select
                :items="remmeiterOptions"
                v-model="dealDetails.remitter"
                class="rounded"
                outlined
                dense
                placeholder="Business User"
                :error-messages="businessUserError"
                @input="$v.dealDetails.remitter.$touch()"
                @blur="$v.dealDetails.remitter.$touch()"
              ></v-select>
            </v-col>
            <v-col cols="12" md="4" lg="4" xs="12">
              <label class="my-0 labelFontsize">Booking Date</label>
              <v-text-field
                type="date"
                required
                outlined
                
                class="rounded"
                dense
                v-model="dealDetails.deal_date"
                :error-messages="dealDateError"
                :min="new Date().toISOString().substr(0, 10)"
                :date-disabled-fn="dateDisabled"
                @input="$v.dealDetails.deal_date.$touch()"
                @blur="$v.dealDetails.deal_date.$touch()"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="4" lg="4" xs="12">
              <label class="my-0 labelFontsize">Deal No</label>
              <v-text-field
                required
                outlined
                dense
                placeholder="Deal No"
                class="rounded"
                :error-messages="dealNoError"
                v-model="dealDetails.deal_no"
                @input="$v.dealDetails.deal_no.$touch();CheckDealNo()"
                @blur="$v.dealDetails.deal_no.$touch()"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row >
            <v-col cols="12" md="4">
              <label class="my-0 labelFontsize">LCY Amount</label>
              <v-text-field
                v-model="dealDetails.lcy_amount"
                @input="
                  $v.dealDetails.lcy_amount.$touch();
                "
                placeholder="LCY Amount"
                class="rounded"
                outlined
                dense
                @blur="$v.dealDetails.lcy_amount.$touch()"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <label class="my-0 labelFontsize"> Value Date</label> {{ dealDetails.purchase_date }}
              <v-text-field
                type="date"
                required
                outlined
                class="rounded"
                dense
                v-model="dealDetails.purchase_date"
                :error-messages="purchaseDateError"
                :min="new Date().toISOString().substr(0, 10)"
                :date-disabled-fn="dateDisabled"
                @input="$v.dealDetails.purchase_date.$touch()"
                @blur="$v.dealDetails.purchase_date.$touch()"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <label class="my-0 labelFontsize">FCY Amount</label>
              <v-text-field
                v-model="dealDetails.pp_amount"
                @input="
                  $v.dealDetails.pp_amount.$touch();
                "
                placeholder="FCY Amount"
                outlined
                dense
                class="rounded"
                @blur="$v.dealDetails.pp_amount.$touch()"
              >
              </v-text-field>
            </v-col>



          </v-row>
          <v-row >
            <v-col cols="12" md="4">
              <label class="my-0 labelFontsize">FCY Rate</label>
              <v-text-field
                v-model="dealDetails.usd_amount"
                @input="
                  $v.dealDetails.usd_amount.$touch();
                "
                placeholder="FCY Rate"
                outlined
                dense
                class="rounded"
                :error-messages="fcyRateError"
                @blur="$v.dealDetails.usd_amount.$touch()"
              >
              </v-text-field>
            </v-col>


            <v-col cols="12" md="4">
              <label class="my-0 labelFontsize">Source of funds</label>
              <v-select
                v-model="dealDetails.source_of_funds"
                :items="fundSourceOption"
                outlined
                dense
                placeholder="Source of funds"
                class="rounded"
                :error-messages="sourceOfFundError"
                @input="$v.dealDetails.source_of_funds.$touch()"
                @blur="$v.dealDetails.source_of_funds.$touch()"
              ></v-select>
            </v-col>

          </v-row>

          <v-toolbar flat dense class="my-5" v-if="updateTrigger">
            <v-toolbar-title>Audit Details</v-toolbar-title>
          </v-toolbar>

          <v-row  v-if="updateTrigger">
            <v-col cols="12" md="6">
              <label class="my-0 labelFontsize">Created By</label>
              <v-text-field
                v-model="dealDetails.created_by"
                disabled
                required
                outlined
                dense
                class="rounded"
                placeholder="Created By"
              >
              </v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <label class="my-0 labelFontsize"> Created Date</label>
              <v-text-field
                type="date"
                required
                outlined
                dense
                class="rounded"
                v-model="dealDetails.created_date"
                disabled
                placeholder="Created Date"
              >
              </v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <label class="my-0 labelFontsize">Updated By</label>
              <v-text-field
                v-model="dealDetails.updated_by"
                disabled
                required
                outlined
                dense
                class="rounded"
                placeholder="Updated By"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <label class="my-0 labelFontsize"> Updated Date</label>
              <v-text-field
                type="date"
                required
                outlined
                dense
                placeholder=" Updated Date"
                class="rounded"
                v-model="dealDetails.updated_date"
                disabled
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row >
            <v-col cols="12" md="12">
              <label class="my-0 labelFontsize">Remarks</label>
              <v-textarea
                outlined
                v-model="dealDetails.remarks"
                rows="3"
                max-rows="6"
                class="rounded"
                placeholder="Remarks"
              ></v-textarea>
            </v-col>
          </v-row>

          <v-row justify="end">
            <v-btn depressed 
            small
              color="primary"
              class="mb-15 me-2 text-capitalize"
              v-on:click="onSubmitFor()"
            >
            <v-icon small class="me-2">mdi-content-save-check-outline</v-icon> {{ updateTrigger ? "Update" : "Submit" }}
            </v-btn>
            <v-btn depressed 
             outlined
             color="primary"
              class="mb-15 me-5 text-capitalize"
              small
            >
            <v-icon small class="me-2">mdi-close-circle-outline</v-icon>Cancel
            </v-btn>
       
           </v-row>
        </v-card-text>
        </v-card>
      </v-form>
    </div>
    <OverlayPageVue :showOverlay="loaderOverlay" />
  </section>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import axios from "axios";
import OverlayPageVue from "@/utils/OverlayPage.vue";
import alerts from "@/mixins/alerts";
import treasuryService from "@/services/TreasuryService/treasuryService.js";

import { required } from "vuelidate/lib/validators";
export default {
  name: "New Business Deals",
  mixins: [alerts],
  components: {
    BreadCrumb,
    OverlayPageVue,
  },
  created() {
    this.getBusinusUsers();
  },
  validations() {
    return {
      dealDetails: {
        remitter: {
          required,
        },
        deal_date: {
          required,
        },
        deal_no: {
          required,
        },
        pp_amount: {
          required,
        },
        usd_amount: {
          required,
        },
        lcy_amount: {
          required,
        },
        source_of_funds: {
          required,
        },
        purchase_date: {
          required,
        },
      },
    };
  },
  computed: {
    businessUserError() {
      const errors = [];
      if (!this.$v.dealDetails.remitter.$dirty) return errors;
      !this.$v.dealDetails.remitter.required &&
        errors.push(this.$t("Deal Type is requried"));
      return errors;
    },
    dealDateError() {
      const errors = [];
      if (!this.$v.dealDetails.deal_date.$dirty) return errors;
      !this.$v.dealDetails.deal_date.required &&
        errors.push(this.$t("Deal Date is requried"));
      return errors;
    },
    dealNoError() {
      const errors = [];
      if (!this.$v.dealDetails.deal_no.$dirty) return errors;
      !this.$v.dealDetails.deal_no.required &&
        errors.push(this.$t("Deal Number is requried"));
      this.deal_no_exsites_error_status === "invalid" &&
        errors.push(this.$t("This Deal No is Already Exists"));
      return errors;
    },
    fcyAmtError() {
      const errors = [];
      if (!this.$v.dealDetails.fcy_amount.$dirty) return errors;
      !this.$v.dealDetails.fcy_amount.required &&
        errors.push(this.$t("USD Amount is requried"));
      return errors;
    },
    fcyRateError() {
      const errors = [];
      if (!this.$v.dealDetails.usd_amount.$dirty) return errors;
      !this.$v.dealDetails.usd_amount.required &&
        errors.push(this.$t("Exchange Rate is requried"));
      return errors;
    },
    lcyAmtError() {
      const errors = [];
      if (!this.$v.dealDetails.lcy_amount.$dirty) return errors;
      !this.$v.dealDetails.lcy_amount.required &&
        errors.push(this.$t("LCY Amount is requried"));
      return errors;
    },
    sourceOfFundError() {
      const errors = [];
      if (!this.$v.dealDetails.source_of_funds.$dirty) return errors;
      !this.$v.dealDetails.source_of_funds.required &&
        errors.push(this.$t("Source of funds is requried"));
      return errors;
    },
    purchaseDateError() {
      const errors = [];
      if (!this.$v.dealDetails.purchase_date.$dirty) return errors;
      !this.$v.dealDetails.purchase_date.required &&
        errors.push(this.$t("Value Date is requried"));
      return errors;
    },
  },
  data() {
    return {
      updateTrigger: false,
      loaderOverlay: false,
      dealList: [],
      remmeiterOptions: [],
      fundSourceOption: [
        { value: "type1", text: "Fund 1" },
        { value: "type2", text: "Fund 2" },
      ],
      targetOfFundOption: [
        { value: "Target Bank USD", text: "Target Bank USD" },
      ],
      dealDetails: {
        remitter: "",
        deal_date: "",
        source_of_funds: "",
        coll_amount: null,
        rate_usd_myr: null,
        usd_amount: null,
        rate_coll: null,
        pp_ccy: "inr",
        pp_amount: null,
        deal_no: null,
        purchase_date: "",
        status: "open",
        bank_poc: "",
        remarks: "",
      },
      alertMsg: {
        status: false,
        text: "",
        timeout: 2000,
        color: "",
        type: "info",
      },
    };
  },

  watch: {
    "$route.query.id": {
      immediate: true,
      handler(newVal) {
        console.log(newVal + "value");
        this.getSelectedDeal();
        // make actions with newVal.page
      },
    },
  },

  mounted() {
    if (this.$route.query.id) {
      this.updateTrigger = true;
      this.getSelectedDeal();
    } else {
      this.updateTrigger = false;
      this.dealDetails.status = "open";
      this.dealDetails.no_of_settlements = 0;
    }
  },

  methods: {
    stoploader() {
      setTimeout(() => {
        this.loaderOverlay = false;
      }, 400);
    },
    getBusinusUsers() {
      axios({
        url: `http://13.126.102.229:5001/api/v1/business_user_kyc/get_all_companies`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("__ac_mn_tk")}`,
        },
      })
        .then((response) => {
          // this.remmeiterOptions = response.data.data;
          this.formatPPoptions(response.data.data);
          console.log(response.data.data);
        })
        .catch((err) => {
          console.log("Data Not Getting", err);
        });
    },
    formatPPoptions(data) {
      if (data && data.length > 0) {
        this.remmeiterOptions = [];
        data.forEach((ele) => {
          this.remmeiterOptions.push({
            text: ele.registered_business_name,
            value: ele.registered_business_name,
          });
        });
      }
    },
    async getSelectedDeal() {
      const routerDataItem = this.$route.query.id;
      this.loaderOverlay = true;
      if (routerDataItem) {
        try {
        const responseData = await treasuryService.getAllBUSdeals();
        console.log(responseData, "response");
        this.stoploader();
        if (responseData && responseData.data.status_code == 200) {
          this.dealList = responseData.data.data[0];
        }    
          let editform = this.dealList.findIndex((data) => {
            return data.deal_id == routerDataItem;
          });
          console.log(editform);
          if (routerDataItem) {
            this.dealDetails = Object.assign({}, this.dealList[editform]);
            this.formatDateFields();
          }
      } catch (err) {
        console.log(err);
        this.loaderOverlay = false;
        this.showAlertError("Fetched data Failed: Something went wrong");
      }
      } else {
        this.stoploader();
        console.log("dealDetails");
        this.dealDetails = {
          remitter: "",
          deal_date: "",
          source_of_funds: "",
          coll_amount: null,
          rate_usd_myr: null,
          usd_amount: null,
          rate_coll: null,
          pp_ccy: "inr",
          pp_amount: null,
          deal_no: null,
          purchase_date: "",
          status: "open",
          bank_poc: "",
          remarks: "",
        };
      }
    },
    async CheckDealNo() {
      try {
        const responseData = await treasuryService.validateDealinBUS(this.dealDetails.deal_no);
        if (responseData && responseData.data.status_code == 200) {
          this.deal_no_exsites_error_status = "valid";
          console.log("inside true");
        }    
        console.log("response", responseData.data.status_code); 
      } catch (err) {
        console.log(err);
        this.deal_no_exsites_error_status = "invalid";
        this.showAlertError("Failed: Something went wrong");
      }
      
    },
    formatDateFields() {
        if(this.dealDetails && this.dealDetails.purchase_date) this.dealDetails.purchase_date = this.dealDetails.purchase_date.slice(0,10);
        if(this.dealDetails && this.dealDetails.created_date) this.dealDetails.created_date = this.dealDetails.created_date.slice(0,10);
        if(this.dealDetails && this.dealDetails.updated_date) this.dealDetails.updated_date = this.dealDetails.updated_date.slice(0,10);

    },
    dateDisabled(ymd, date) {
      const weekday = date.getDay();
      const day = date.getDate();
      return (
        weekday === 0 ||
        weekday === 6 ||
        day === 4 ||
        day === 5 ||
        day === 6 ||
        day === 7 ||
        day === 8 ||
        day === 9 ||
        day === 10 ||
        day === 11 ||
        day === 12 ||
        day === 13 ||
        day === 14 ||
        day === 15 ||
        day === 16 ||
        day === 17 ||
        day === 18 ||
        day === 19 ||
        day === 20 ||
        day === 21 ||
        day === 22 ||
        day === 23 ||
        day === 24 ||
        day === 25 ||
        day === 26 ||
        day === 27 ||
        day === 28 ||
        day === 29 ||
        day === 30 ||
        day === 31
      );
    },

    onSubmitFor() {
      if (this.dealDetails.deal_id) {
        console.log("details");
        this.updateDeal();
      } else {
        console.log("else");
        this.postDeal();
        // console.log('update')
      }
    },
    async updateDeal() {
      console.log(`dealDetails: ${JSON.stringify(this.dealDetails)}`);
      const request = this.getRequest();
      const date1 = new Date(request.deal_date);
        const mnth1 = ("0" + (date1.getMonth() + 1)).slice(-2);
        const day1 = ("0" + date1.getDate()).slice(-2);
        request.deal_date = [date1.getFullYear(), mnth1, day1].join("-");

        this.loaderOverlay = true;
        try {
        const responseData = await treasuryService.updateBUSdeals( request.deal_id,request);
        console.log(`responseData: ${JSON.stringify(responseData)}`);
        if (responseData && responseData.data.status_code == 200) {
         this.showAlertSuccess(responseData.data.message)
         this.stoploader();
         setTimeout(() => this.$router.push({ name: "New Business Deals" }), 300);
        }  else {
          this.loaderOverlay = false;
          this.showAlertError('Failed:'+responseData.data.message)
        }  
        console.log("respose data", responseData);
      } catch (err) {
        console.log(err);
        this.loaderOverlay = false;
        this.showAlertError("Failed: Something went wrong");
      }
    },
    async postDeal() {
        console.log(`dealDetails: ${JSON.stringify(this.dealDetails)}`);
      this.$v.$touch();
      if (this.$v.$invalid) {
        console.log('Form has some error')
        return;
      }
      const request = this.getRequest();
      request.deal_date = request.deal_date.toISOString().slice(0,10);
      this.loaderOverlay = true;
        try {
        const responseData = await treasuryService.addBUSdeals(request);
        console.log(`responseData: ${JSON.stringify(responseData)}`);
        if (responseData && responseData.data.status_code == 200) {
         this.showAlertSuccess(responseData.data.message)
         this.stoploader();
         setTimeout(() => this.$router.push({ name: "New Business Deals" }), 300);
        }  else {
          this.loaderOverlay = false;
          this.showAlertError('Failed:'+responseData.data.message)
        }  
        console.log("respose data", responseData);
      } catch (err) {
        console.log(err);
        this.loaderOverlay = false;
        this.showAlertError("Failed: Something went wrong");
      }
     
    },
    getRequest() {
      console.log("temp", this.dealDetails)
      const req = this.dealDetails;
      for (const key of Object.keys(req)) {
        console.log(key, req[key]);
        if (key === 'deal_date' || key === 'purchase_date' || key === 'updated_date' ) {
          if (req[key]) {
            req[key] = new Date(req[key]);
          }
        }
      }
      return req;
    },
  },
};
</script>

<style lang="scss" scoped></style>
